import { cva as e } from "class-variance-authority";
// src/design/forms/editable/style.ts
var t = e("flex flex-col gap-1 w-full", {
	variants: { disabled: {
		true: "opacity-90 cursor-not-allowed",
		false: ""
	} },
	defaultVariants: { disabled: !1 }
}), n = e("text-sm font-medium text-foreground", {
	variants: {
		required: {
			true: "after:content-[\"*\"] after:ml-0.5 after:text-destructive",
			false: ""
		},
		disabled: {
			true: "text-muted-foreground",
			false: ""
		}
	},
	defaultVariants: {
		required: !1,
		disabled: !1
	}
}), r = e("relative flex items-center gap-2 w-full"), i = e([
	"flex w-full rounded-md border border-input-border bg-input-background",
	"text-sm text-foreground placeholder:text-sm placeholder:text-muted-foreground/70",
	"transition-colors duration-normal",
	"hover:bg-muted",
	"focus-visible:outline-hidden focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
	"disabled:cursor-not-allowed disabled:opacity-90 disabled:bg-muted"
], {
	variants: {
		size: {
			sm: "h-8 px-2.5 py-1.5 text-xs",
			md: "h-10 px-3 py-2",
			lg: "h-12 px-4 py-3 text-base"
		},
		hasControls: {
			true: "",
			false: ""
		},
		invalid: {
			true: "border-destructive focus-visible:border-destructive",
			false: ""
		}
	},
	defaultVariants: {
		size: "sm",
		hasControls: !1,
		invalid: !1
	}
}), a = e([
	"flex w-full rounded-md border border-transparent bg-transparent",
	"text-sm text-foreground",
	"transition-colors duration-normal cursor-text",
	"hover:bg-muted",
	"focus-ring",
	"data-placeholder-shown:text-muted-foreground"
], {
	variants: { size: {
		sm: "min-h-8 px-2.5 py-1.5 text-xs",
		md: "min-h-8 px-3 py-1.5",
		lg: "min-h-10 px-4 py-2 text-base"
	} },
	defaultVariants: { size: "md" }
}), o = e("flex items-center gap-1"), s = e([
	"inline-flex items-center justify-center rounded-md",
	"text-sm font-medium transition-colors",
	"focus-ring",
	"disabled:pointer-events-none disabled:opacity-90",
	"bg-primary text-primary-foreground hover:bg-primary"
], {
	variants: { size: {
		sm: "h-6 w-6 p-0",
		md: "h-8 w-8 p-0",
		lg: "h-10 w-10 p-0"
	} },
	defaultVariants: { size: "md" }
}), c = e([
	"inline-flex items-center justify-center rounded-md",
	"text-sm font-medium transition-colors",
	"focus-ring",
	"disabled:pointer-events-none disabled:opacity-90",
	"bg-muted text-foreground hover:bg-muted"
], {
	variants: { size: {
		sm: "h-6 w-6 p-0",
		md: "h-8 w-8 p-0",
		lg: "h-10 w-10 p-0"
	} },
	defaultVariants: { size: "md" }
}), l = e([
	"inline-flex items-center justify-center rounded-md",
	"text-sm font-medium transition-colors",
	"focus-ring",
	"disabled:pointer-events-none disabled:opacity-90",
	"bg-muted text-foreground hover:bg-muted"
], {
	variants: { size: {
		sm: "h-7 px-2 text-xs",
		md: "h-8 px-3",
		lg: "h-10 px-4"
	} },
	defaultVariants: { size: "md" }
}), u = (e) => ({
	root: (e) => t(e),
	label: (e) => n(e),
	area: () => r(),
	input: (t) => i({
		size: e?.size,
		hasControls: t
	}),
	preview: () => a({ size: e?.size }),
	control: () => o(),
	submitTrigger: () => s({ size: e?.size }),
	cancelTrigger: () => c({ size: e?.size }),
	editTrigger: () => l({ size: e?.size })
});
export { r as areaStyles, c as cancelTriggerStyles, o as controlStyles, l as editTriggerStyles, u as getStyles, i as inputStyles, n as labelStyles, a as previewStyles, t as rootStyles, s as submitTriggerStyles };

//# sourceMappingURL=style.js.map